import { render, staticRenderFns } from "./CustomerVehicleList.vue?vue&type=template&id=51ff3b3f&scoped=true&lang=pug"
import script from "./CustomerVehicleList.vue?vue&type=script&lang=js"
export * from "./CustomerVehicleList.vue?vue&type=script&lang=js"
import style0 from "./CustomerVehicleList.vue?vue&type=style&index=0&id=51ff3b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff3b3f",
  null
  
)

export default component.exports